import { BaseContainerModel } from '../base-container.model';
import { bl_t2t_comp_branch_entity_link_RowCLass } from '../../dbschema/bl_t2t_comp_branch_entity_link.model';

export class T2TBusinessMappingContainerModel extends BaseContainerModel {
  bl_t2t_comp_branch_entity_link: bl_t2t_comp_branch_entity_link_RowCLass = new bl_t2t_comp_branch_entity_link_RowCLass();
}